import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { staticPagesInitialState } from './constants';
import { reducers } from './reducers';

export const staticPagesSlice = createSlice({
  name: 'staticPage',
  initialState: staticPagesInitialState,
  reducers,
  extraReducers,
});

export const { reducer: staticPagesReducer } = staticPagesSlice;

export const { clearSections, updateSections } = staticPagesSlice.actions;
export default staticPagesReducer;
